if (!IsIframe()){
  
}

$(function() {
  "use strict";
  
  CartJS.init(theme.cart(), {
    "debug": false,
    "requestBodyClass": "loadingCart",
    "moneyFormat": $('body').data('cartjs-money-format'),
    "moneyWithCurrencyFormat": $('body').data('cartjs-money-with-currency-format')
  });
  
  rivets.bind(jQuery('.cart-item-count, #cart-drop, #mobile-cart, #cartform'), {cart: CartJS.cart});
  
  
  
  if ($('.infinite-pagination').length > 0) {
  	infinite.init();
  }
  
  searchAutocomplete.init();

  
    addToCart.init();
  
  
  if ($('.section-cart-template').length > 0) {
    cartPage.init();
  }
  
  if ($('.login-form').length > 0) {
  	account.init();
  }
  
  
      
  if ($('.section-lookbook').length > 0) {
    quickShop.init();
  }
});

var account = {
  init: function() {
    $('body').on('click', '#RecoverPassword, #HideRecoverPasswordLink', function(e) {
      e.preventDefault();
      $('#recover, #login').toggleClass('uk-hidden');
    });
  }
}

var cartPage = {
  init: function() {
    if ($('.section-cart-template').data('exit-modal') === true && $('.section-cart-template').data('cart-count') > 0) {
      ouibounce(document.getElementById('cart-exit-intent'), {
        aggressive: true,
        callback: function() { 
          UIkit.modal('#cart-exit-intent').show();
        }
      });
    }
  }
}

var addToCart = {
  init: function() {
  	$('body').on('submit', ".js-ajax-product-form", function(e) {
      e.preventDefault();
      
      var id = $(this).find("[name='id']").val(),
          qty = $(this).find("#quantity").val();
      
      $('.add-to-cart .uk-cart').addClass('uk-hidden');
      $('.add-to-cart .uk-spinner').removeClass('uk-hidden');
      $('.add-to-cart .uk-check').addClass('uk-hidden');
      $('.add-to-cart .uk-error').addClass('uk-hidden');
      $('.no-stock-warning').addClass('uk-hidden');
     
      CartJS.addItem(id, qty, {
      
      },{
          "success": function(data, textStatus, jqXHR) {
            
            $('.add-to-cart .uk-check').removeClass('uk-hidden');
            $('.add-to-cart .uk-spinner').addClass('uk-hidden');
            setTimeout(function(){
              $('.add-to-cart .uk-check').addClass('uk-hidden');
              $('.add-to-cart .uk-cart').removeClass('uk-hidden');
            }, 1000);
            
            
            	var showCartDrop = true;
            
            if ($('.js-product').data('upsell') === 'modal' && $('#modal-upsell-product').hasClass('viewed') === false && $('.js-product').data('enable-upsell') === true) {
              UIkit.modal('#modal-upsell-product').show();
              
              	showCartDrop = false;
              
            }
            
            UIkit.util.on('#modal-upsell-product', 'shown', function () {
              if ($('.upsell-product-slider').hasClass('slick-initialized') === false) {
                $('.upsell-product-slider').slick({
                  "lazyLoad": 'progressive',
                  "adaptiveHeight": true,
                  arrows: false,
                  dots: true,
                  "infinite": false,
                  "vertical": false,
                  "verticalSwiping": false,
                  "slidesToShow": 3,
                  "slidesToScroll": 1,
                  "focusOnSelect": true,
                  "customSlideAdvancement": false,
                  responsive: [
                    {
                      breakpoint: 640,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: true
                      }
                    }
                  ]
                });
                
                $('#modal-upsell-product').addClass('viewed');
              }
            });
            
            
              if ($(window).width() > 639) {
                UIkit.util.on('#modal-upsell-product', 'hidden', function () {
                  if (showCartDrop === false) {
                    UIkit.drop('#cart-drop-wrapper').show();
                    setTimeout(function(){ 
                        UIkit.drop('#cart-drop-wrapper').hide();
                    }, 5000);
                  }
                });

                if (showCartDrop === true) {
                  UIkit.drop('#cart-drop-wrapper').show();
                  setTimeout(function(){ 
                      UIkit.drop('#cart-drop-wrapper').hide();
                  }, 5000);
                }
              } else {
                UIkit.util.on('#modal-upsell-product', 'hidden', function () {
                  if (showCartDrop === false) {
              		UIkit.offcanvas('#mobile-cart').show();
                  }
                });
                
                if (showCartDrop === true) {
                  UIkit.offcanvas('#mobile-cart').show();
                }
              }
            
            
          },
          "error": function(jqXHR, textStatus, errorThrown) {
            
            $('.add-to-cart .uk-error').removeClass('uk-hidden');
            $('.add-to-cart .uk-spinner').addClass('uk-hidden');
            setTimeout(function(){
              $('.add-to-cart .uk-error').addClass('uk-hidden');
              $('.add-to-cart .uk-cart').removeClass('uk-hidden');
            }, 1000);
          }
      });
      
    });
  }
}

$(document).on('cart.requestStarted', function(event, cart) {

});

$(document).on('cart.requestComplete', function(event, cart) {
  
    var treshold = 20000,
        cartDifference = treshold - cart.total_price;
    $('.treshold-update').empty().append('<span class="money">'+Shopify.formatMoney(cartDifference, $('body').data('money-format'))+'</span>');
  
  
  if (!IsIframe()){
    
  }
});

$(document).on('cart.ready', function(event, cart) {
  
  
    var treshold = 20000,
        cartDifference = treshold - cart.total_price;
    $('.treshold-update').empty().append('<span class="money">'+Shopify.formatMoney(cartDifference, $('body').data('money-format'))+'</span>');
  
  
  $('body').removeClass('loading-cart');
  
  if (!IsIframe()){
    
  }
});


var quickShop = {
  init: function(){
  	$('body').on('click', '.js-quick-shop-link', function(e){
      e.preventDefault();
      var productID = $(this).data('product-id');
	  UIkit.modal('#quick-shop-'+productID).show();
      quickShop.quickShop($('#quick-shop-'+productID));
    });
    
    var ids = [];
    var $buttons = $('.js-quick-shop-link');
  
    $buttons.each(function() {
      var id = $(this).data('product-id');
      var modalId = '#quick-shop-' + id;
  
      if (ids.indexOf(id) > -1) {
        $('.quick-shop-modal[data-product-id="'+ id +'"]').each(function(i) {
          if (i > 0) {
            $(this).remove();
          }
        });
        return;
      }
      ids.push(id);
    });
    
  },
  quickShop: function($parent) {
    //console.log(parent);
    var main = $parent.find('.qs-main-images');
    var secondary = $parent.find('.qs-secondary-images');
    var secondaryVertical = $parent.find('.vertical .qs-secondary-images');
    var secondaryHorizontal = $parent.find('.horizontal .qs-secondary-images');
    if(!main.hasClass('slick-initialized')) {
      $(main).slick({
        "lazyLoad": 'progressive',
        arrows: false,
        "adaptiveHeight": false,
        "infinite": false,
        asNavFor: secondary,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: true
            }
          }
        ]
      });
      $(secondaryVertical).slick({
        "lazyLoad": 'progressive',
        "adaptiveHeight": true,
        arrows: false,
        dots: false,
        "infinite": false,
        "vertical": true,
        "verticalSwiping": true,
        "slidesToShow": 4,
        "slidesToScroll": 1,
        "asNavFor": main,
        "focusOnSelect": true,
        "customHeightMatching": true,
        "customSlideAdvancement": true
      });

      $(secondaryHorizontal).slick({
        "lazyLoad": 'progressive',
        "adaptiveHeight": true,
        arrows: false,
        dots: false,
        "infinite": false,
        "vertical": false,
        "verticalSwiping": true,
        "slidesToShow": 4,
        "slidesToScroll": 1,
        "asNavFor": main,
        "focusOnSelect": true,
        "customHeightMatching": false,
        "customSlideAdvancement": true
      });
      
      if ($(main).data('enlarge') == 'zoom') {
        product.zoom($(main).find('.slide:eq(0) a'));
        $(main).on('beforeChange', function(event, slick, currentSlide, nextSlide){
          product.zoom($(main).find('.slide:eq('+nextSlide+') a'));
        });
      }
      
      var form = $parent.find(".product-form-with-options");
      $(form).each(function() {
       new Shopify.OptionSelectors($(form).data("select-id"), { product: $(form).data("product"), onVariantSelected: quickShop.qsOnVariantSelect, enableHistoryState: false });
      });
      
      
        $('body').on('change', '.quick-shop .swatch :radio', function() {
          var optionIndex = $(this).closest('.swatch').attr('data-option-index');
          var optionValue = $(this).val();
          var parentForm = $(this).closest('.product-form');

          var option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
          var option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
          var option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';

          $(this)
            .closest('form')
            .find('.single-option-selector')
            .eq(optionIndex)
            .val(optionValue)
            .trigger('change');
        });
      
    }
  },
  qsOnVariantSelect: function(variant, selector) {
  	var $product = $('#quick-shop-' + selector.product.id);
    var $productForm = $('form.product-form', $product);
    var enableInventory = $productForm.data('enable-inventory');

    if (enableInventory == true) {
      //Manage Inventory
      var inventory_quantity = $('.product-form__variants option[value="'+variant.id+'"]', $product).data('variant-inventory');
      if (inventory_quantity == 1) {
        var pluralize_product = 'product';
      } else {
        var pluralize_product = 'products';
      }

      var hurry_only = 'Hurry!! Only';
      var products_left_in_stock = 'left';

      if(inventory_quantity >= 100) {
        if (variant.available == true) {
          $('.progress-wrapper', $product).removeClass('uk-hidden');
          $('.stock-qty-wrapper', $product).empty().append('We just restocked this product.');
          $('.progress-bar', $product).css('width', '95%');
          if($('.quantity', $product).length > 0) {
              $('.quantity', $product).attr('max', 100);
          }
        } else {
          $('.progress-wrapper', $product).addClass('uk-hidden');
        }
      } else {
        if (variant.available == true) {
          $('.progress-wrapper', $product).removeClass('uk-hidden');
          $('.stock-qty-wrapper', $product).empty().append(hurry_only+' <span id="stock-qty">'+inventory_quantity+' '+pluralize_product+'</span> '+products_left_in_stock);
          $('.progress-bar', $product).css('width', inventory_quantity+'%');
          if($('.quantity', $product).length > 0) {
            $('.quantity', $product).attr('max', inventory_quantity);
            if($('.quantity', $product).val() > inventory_quantity) {
              $('.quantity', $product).val(inventory_quantity);
            }
          }
        } else {
          $('.progress-wrapper', $product).addClass('uk-hidden');
        }
      }
      //END Manage Inventory
    }

    if (variant && variant.featured_image && $product.is(":visible")) {
      var $mainImages = $('.qs-main-images', $product);
      $mainImages.each(function() {
        var $slider = $(this);

        if ($slider.is(":visible")) {
          var index = $('[data-image-id="' + variant.featured_image.id + '"]', $product).data('index');
          $slider.slick('slickGoTo', parseInt(index), true);
        }
      });
    }

    if(variant) {
      if(variant.sku != '') {
        $('.sku span', $product).text(variant.sku);
        $('.sku', $product).removeClass('uk-hidden');
      } else {
        $('.sku', $product).addClass('uk-hidden');
      }

      
        for (var i=0,length=variant.options.length; i<length; i++) {
          var radioButton = $('.swatch[data-option-index="' + escape(i) + '"] :radio[value="' + variant.options[i].replace(/\"/g,'\\"') +'"]', $product);
          if (radioButton.length) {
            radioButton.get(0).checked = true;
          }
        }
      
    }

    var save = 'Save';
    var sale = 'Sale';
    var sold = 'Sold out';

    if (variant && variant.available == true) {
      if (variant.price > 0) {
        $('.current-price', $product).empty().append('<span class="money">' + Shopify.formatMoney(variant.price, $productForm.data('money-format')) + '</span>').show();
      } else {
        $('.current-price', $product).empty().append("FREE").show();
      }
      $('.sold-out', $product).addClass('uk-hidden');
      $('.current-price', $product).removeClass('uk-hidden');
      if(variant.price < variant.compare_at_price){
        var amount = variant.compare_at_price - variant.price;
        $('.was-price', $product).empty().append('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')) + '</span>').removeClass('uk-hidden');
        $('.sale.amount', $product).empty().append('<span class="money">' + save+' '+Shopify.formatMoney(amount)+ '</span>').removeClass('uk-hidden');
        $('.sale.savings', $product).empty().append(save+' '+parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)+'%').removeClass('uk-hidden');
        $('.sale.text', $product).empty().append(sale).removeClass('uk-hidden');
      } else {
        $('.was-price', $product).addClass('uk-hidden');
        $('.sale.amount', $product).addClass('uk-hidden');
        $('.sale.savings', $product).addClass('uk-hidden');
        $('.sale.text', $product).addClass('uk-hidden');
      }

      $('.add-to-cart', $product).removeAttr('disabled').find('span.text').text($('.add-to-cart', $product).data('add-text'));
      $('.shopify-payment-button', $product).show();
    } else {
      $('.sold-out', $product).removeClass('uk-hidden');
      $('.was-price', $product).addClass('uk-hidden');
      $('.sale.amount', $product).addClass('uk-hidden');
      $('.sale.savings', $product).addClass('uk-hidden');
      $('.sale.text', $product).addClass('uk-hidden');
      $('.current-price', $product).addClass('uk-hidden');

      $('.add-to-cart', $product).attr('disabled', 'disabled').find('span.text').text($('.add-to-cart', $product).data('sold-text'));
      $('.shopify-payment-button', $product).hide();
    }
    
  }
}



var infinite = {
  init: function() {
    var infinite = new Waypoint.Infinite({
      element: $('#products-container')[0],
      more: ".infinite-more-link",
      items: ".infinite-item",
      offset: 'bottom-in-view',
      onBeforePageLoad: function() {
        //console.log('Before');
        $('.infinite-more-link').css('opacity', '1').show();
      },
      onAfterPageLoad: function($items) {
        //console.log('After');
        var currentProductsNumber = parseInt($('.products-number').html()),
            futureProductsNumber = currentProductsNumber+$items.length;
        $('.products-number').empty().append(futureProductsNumber);
        $('.infinite-more-link').css('opacity', '0').hide();
        
        
        $(window).trigger('resize');
        if ($('.infinite-more-link').length > 0) {
          var nextPage = $('.infinite-more-link').attr('href');
          $.get(nextPage, $.proxy(function(data) {
            console.dir(data);
          }, this));
        }
      }
    })
  }
}

var searchAutocomplete = {
  init: function(){
    var e = null;
    $('form[action="/search"]').each(function() {
        var t = $(this).find('input[name="q"]');
        t.on("focus", function() {
            $(this).closest("form").find(".search-results").fadeIn(200)
        }), t.attr("autocomplete", "off").bind("keyup change focus", function() {
            var t = "*" + $(this).val() + "*",
                a = $(this).closest("form"),
                s = "/search?type=product&q=" + t,
                n = a.find(".search-results");
            t.length > 3 && t != $(this).attr("data-old-term") && ($(this).attr("data-old-term", t), null != e && e.abort(), e = $.getJSON(s + "&view=json", function(e) {
                n.empty(), 0 == e.results_count ? (n.empty().append('<li><div class="uk-placeholder">0 results for ' + t + "</div></li>"), n.fadeIn(200)) : ($.each(e.results, function(e, t) {
                    var a = $("<a></a>").attr("href", t.url);
                    a.append('<span class="thumbnail"><img src="' + t.thumbnail + '" />'), a.append('<div class="uk-text-left"><span class="title">' + t.title + "</span></div>"), a.append('<div class="price new_price"><span>' + t.new_price + "</span>"), "0.00lei" != t.old_price && a.append('<div class="price old_price"><s>' + t.old_price + "</s></div>"), a.wrap("<li></li>"), n.append(a.parent())
                }), e.results_count > 5 && n.append('<li><span class="title"><a href="' + s + '">See all results (' + e.results_count + ")</a></span></li>"), n.fadeIn(200))
            }))
        })
    })
    $('form[action="/search"]').find('input[name="q"]').on("focusout", function() {
        setTimeout(function() {
            $(".search-results").hide(), $(".search-backdrop").fadeOut(200)
        }, 200)
    })
  }
}


var styleID = 'styles';
if (!document.getElementById(styleID))
{
    var head  = document.getElementsByTagName('head')[0];
    var link  = document.createElement('link');
    link.id   = styleID;
    link.rel  = 'stylesheet';
    link.type = 'text/css';
    link.href = '//www.sheis3125.com/cdn/shop/t/3/assets/styles.scss.css?v=156725138816066763231614278594';
    link.media = 'screen';
    head.appendChild(link);
}
  

  
$(document).on('shopify:section:load', function(e){
  //console.log(e);
  var blockId = e.detail.blockId;
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  
  $(window).trigger('resize');
  
  if ($parentSection.hasClass('slideshow-section')){
    $('.slideshow').slick({
      "nextArrow": '<button class="slick-next slick-arrow" aria-label="Previous" type="button" style=""><span class="uk-icon" uk-icon="chevron-right"></span></button>',
      "prevArrow": '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><span class="uk-icon" uk-icon="chevron-left"></span></button>',
      "lazyLoad": 'progressive',
      "adaptiveHeight": true,
      "infinite": false
    });
    $('.slideshow').on('afterChange', function(event, slick, currentSlide){
      //console.log(slick);
      var index = currentSlide+1;

      if (slick.$slider.data('kenburns') == true) {
        $('.slideshow img').removeClass('uk-animation-kenburns');
        $('.slideshow .slick-slide:nth-child('+index+') img').addClass('uk-animation-kenburns');
      }

      $('.slideshow .slide-caption').removeClass('uk-animation-slide-top-small');
      $('.slideshow .slick-slide:nth-child('+index+') .slide-caption').addClass('uk-animation-slide-top-small');
    });

    $(".slideshow").slick("refresh");
  }
  
  if ($parentSection.hasClass('slideshow-section')){
    setTimeout(function(){
  	  $(window).resize();
    },200);
  }
  
  if ($parentSection.hasClass('collection-page') || $parentSection.hasClass('blog-page')){
    if ($('.load-infinite').length > 0) {
  	  infinite.init();
    }
  }
  
  if ($parentSection.hasClass('product-page')){
    product.init();
  }
  
  rivets.bind(jQuery('.cart-item-count, #cart-drop, #mobile-cart, #cart-page-tamplate'), {cart: CartJS.cart});
});

$(document).on('shopify:block:select', function(e){
  //console.log(e);
  var blockId = e.detail.blockId;
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  
  if ($parentSection.hasClass('slideshow-section')){
    var index = $('.slide-'+e.detail.sectionId+'-'+blockId).parents('.slick-slide').data('slick-index');
    //console.log(index);
    $('.slideshow').slick('slickGoTo', index);
    $('.slideshow').slick('slickPause');
  }
});

$(document).on('shopify:block:deselect', function(e){
  //console.log(e);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  if ($parentSection.hasClass('slideshow-section')){
    $('.slideshow').slick('slickPlay');
  }
});

$(document).on('shopify:section:reorder', function(e){
	//console.log(e);
});

$(document).on('shopify:section:load', function(e){
  //console.log(e);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
});

$(document).on('shopify:section:unload', function(e){
  //console.log(e);
  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  
  if ($parentSection.hasClass('slideshow-section')){
  	$('.slideshow').slick('unslick');
  }
});

$(document).on('shopify:section:select', function(e){
  //console.log(e);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  $('.shopify-section').addClass('disable');
  $parentSection.removeClass('disable').addClass('enable');
  
});

$(document).on('shopify:section:deselect', function(e){
  //console.log(e);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  $('.shopify-section').removeClass('disable');
  $parentSection.removeClass('enable');
});
  
function IsIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}